export enum CreateEventTypes {
  COPY_FROM_PAST = 'copy',
  CREATE_FROM_TEMPLATE = 'template',
  CREATE_NEW_EVENT = 'new-event',
}
